import $ from 'jquery';
import Filter from './Filter';

// The search filter
export default class TabFilter extends Filter {

  constructor($element, options = {}) {
    super($element, options);
    if ($element.length === 0) return false;
    
    this.filterType = "TabFilter";
    this.emptyValue = 0;

    $element.on('click', "ul li", this.onClick.bind(this));
  }

  getValue() {
    var value = this.getElement().find('li.active').data('slug');

    return (!value) ? false : value;
  }

  setValue(values) {
    if( !values ) {
      values = [this.emptyValue];
    }

    if( typeof values == "string" ) {
      values = values.split(/\s|\+/);
    }

    this.getElement().find("li.active").removeClass('active');
    this.getElement().find('[data-slug=' + values[0] + ']').addClass('active');
  }

  getKey() {
    return this.getElement().find('ul[data-key]').data('key');
  }

  onClick(ev) {
    ev.preventDefault();
    var slug = $(ev.currentTarget).data('slug');
    this.setValue(slug);
    $.messages.send({
      type: 'FILTER/VALUE_CHANGED',
      key: this.getKey(),
      value: slug,
      sender: this
    });
  }

}



/** WEBPACK FOOTER **
 ** ../assets/js/filters/TabFilter.js
 **/